<div *ngIf="process; else no_tasks">
    <h2 ngClass="{{process.isStep ? 'step-header' : ''}}">{{ process.isStep ? 'Step ' +
        process.stepIndex + ':
        ' : ''}}{{ process.typeStr }}</h2>
    <h4>{{process.hasSteps ? 'Summary:' : 'Statistic:'}}</h4>

    <div class="mat-typography">
        <app-process-status-row [process]="process"></app-process-status-row>
        <app-process-statistic-section [process]="process"></app-process-statistic-section>
        <p *ngIf="process['zoningCodeId'] !== undefined">Zoning Code Id: {{ process.zoningCodeId }} </p>
        <p *ngIf="process['zcGridicsId'] !== undefined">Zoning Code Gridics Id: {{ process.zcGridicsId }} </p>
        <p *ngIf="process['zcVersionIds'] !== undefined">Related Zoning Code Versions Ids: {{
            process.zcVersionIds.join(',
            ') }} </p>
        <p *ngIf="process['removePropertyRecords'] !== undefined">Remove Property Records: {{
            process.removePropertyRecords }} </p>
        <p *ngIf="process['isZoningCodeRemoved'] !== undefined">Is Zoning Code Removed: {{
            process.isZoningCodeRemoved }}
        </p>
        <p *ngIf="process['removedZCVersionsCount'] !== undefined">Removed Zoning Code Versions Count: {{
            process.removedZCVersionsCount }} </p>
    </div>
</div>

<ng-template #no_tasks>
    <h2>Tasks are not found</h2>
</ng-template>